import { makeStyles } from '@material-ui/core/styles';
import { ExtLink } from '@/components/global';
import { Truncate } from '@/utils';

const useStyles = makeStyles(({ breakpoints: BP }) => ({
  card: {
    width: '23%',
    display: 'flex',
    flexDirection: 'column',
    color: '#283142',

    transition: 'all 0.25s ease-in-out',

    '& img': {
      borderRadius: 10,
      height: 180,
    },

    '& h3': {
      fontSize: 15,
      fontWeight: 'bold',
      color: '#0f1f35',
      margin: '10px 0',
      height: 40,
      '&:before': {
        content: "''",
        backgroundColor: '#0f1f35',
        width: 30,
        height: 5,
        borderRadius: 5,
        margin: 'auto 0 auto 10px',
        display: 'inline-block',
      },
    },
    '& span': {
      fontSize: 14,
      color: '#0f1f35',
      textAlign: 'justify',
      lineHeight: 1.36,
      minHeight: 80,
      display: 'block',
    },
    '& h5': {
      fontSize: 12,
      color: '#004f9d',
      marginBottom: 10,
    },
    '&:hover': {
      transform: 'translateY(-15px)',
    },
    [BP.down('sm')]: {
      width: '70vw',
      margin: '0 10px',
      '&:hover': {
        transform: 'none !important',
      },
      '& img': {
        width: '70vw',
      },
    },
  },
  content: {
    padding: '0 5px',
  },
}));

export default function BlogCard({ item = {} }) {
  const cls = useStyles();
  return (
    <ExtLink href={item.link} className={cls.card}>
      <img src={item.img} alt="Post" loading="lazy" />
      <div className={cls.content}>
        <h3>{item.title}</h3>
        <span>{Truncate(item.des, 120)}</span>
        <h5>{item.cat}</h5>
      </div>
    </ExtLink>
  );
}
